import { ErrorMessageComponent } from "@/Common/Components/Errors/ErrorMessageComponent";
import { InformationLoadingComponent } from "@/Common/Components/Loader/InformationLoadingComponent";
import { IPortalManagementPopupErrorFunction } from "./LinkMylePatientToPortalAccountDialog";
import { PortalActionConfirmationGenericPopupState } from "./PortalActionConfirmationGenericPopup";

interface ResendPortalEmailConfirmationPopupProps {
    confirmationMessage: JSX.Element | string;
    confirmationTitle: string;
    onCloseCallback: () => void;
    confirmationCallback: (onError: IPortalManagementPopupErrorFunction) => void;
}

class ResendPortalEmailConfirmationPopupState {
    public errors: string[];
    public isLoading: boolean;
}

class ResendPortalEmailConfirmationPopup extends React.Component<ResendPortalEmailConfirmationPopupProps, ResendPortalEmailConfirmationPopupState> {
    private componentId = "portal_resend_email";

    constructor(props: ResendPortalEmailConfirmationPopupProps) {
        super(props);

        this.state = new ResendPortalEmailConfirmationPopupState();
    }

    public componentDidMount(): void {
        overlayStore.showOverlay("ResendPortalEmailConfirmationPopup");

        const element = $("#" + this.componentId);
        const containment = document.body;
        const dragOptions = {
            containment: containment,
            handle: ".dragHandle",
            stop: function() {
                element.draggable("destroy");
                element.css("height", "auto");
                window.setTimeout(() => element.draggable(dragOptions), 50);
            }
        };
        element.draggable(dragOptions);
        $(window).trigger("resize");
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay("ResendPortalEmailConfirmationPopup");
    }

    public render(): JSX.Element {
        return (

            <div className="popup portal-popup" id={this.componentId}>

                <div className="portal-messages-header">
                    <div className="itemGrow dragHandle">
                        <h3>{this.props.confirmationTitle}</h3>
                    </div>
                    <div>
                        <a className="close" onClick={this.onCloseDialog.bind(this)} aria-label="Close" style={{ paddingTop: "10px" }}>×</a>
                    </div>
                    <h4 />
                </div>

                <div className="p-body myle-form portal-messages-body">

                    <ErrorMessageComponent errors={this.state.errors} />

                    {this.state.isLoading && (this.state.errors == null || this.state.errors.length == 0) &&
                        <InformationLoadingComponent smallVersion={true} customMessage={cacheStore.GetString("WaitForPortalLabel")} />
                    }
                    <span> {this.props.confirmationMessage}</span>
                </div>
                <div className="p-footer">
                    {this.props.confirmationCallback
                        ? (
                            <div className="col-lg-12 text-right">
                                <button onClick={this.onCloseDialog.bind(this)} className="btn btn-default push-right-5"><span>{cacheStore.GetString("CancelLabel")}</span></button>
                                <button onClick={this.onConfirmClicked.bind(this)} disabled={this.state.isLoading} className="btn btn-primary"><span>{cacheStore.GetString("ConfirmLabel")}</span></button>
                            </div>
                        )
                        : (
                            <div className="col-lg-12 text-right">
                                <button onClick={this.onCloseDialog.bind(this)} className="btn btn-default push-right-5"><span>{cacheStore.GetString("CloseLabel")}</span></button>
                            </div>
                        )
                    }

                </div>
            </div>
        );
    }

    private onCloseDialog(): void {
        if (this.props.onCloseCallback != null)
            this.props.onCloseCallback();
    }

    private onConfirmClicked(): void {
        if (this.props.confirmationCallback != null) {
            this.props.confirmationCallback(this.onError.bind(this));
        }
    }

    private onError(error: string): void {
        var s = new PortalActionConfirmationGenericPopupState();
        s.errors = [error];
        this.setState(s);
    }
}

export { ResendPortalEmailConfirmationPopup };
